import { render, staticRenderFns } from "./DashboardNotifications.vue?vue&type=template&id=2a19a1b7&scoped=true&"
import script from "./DashboardNotifications.vue?vue&type=script&lang=js&"
export * from "./DashboardNotifications.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNotifications.vue?vue&type=style&index=0&id=2a19a1b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a19a1b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer})
